import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const ChapterNext = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="ChapterNext" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M23 22H21V13.2354L10.5879 20.8086C10.2837 21.0297 9.88103 21.0623 9.5459 20.8916C9.21076 20.7209 9 20.3761 9 20V15.8682L1.55469 20.832C1.2479 21.0366 0.853438 21.0557 0.52832 20.8818C0.203163 20.7078 0 20.3688 0 20V3.5C0 3.12447 0.210565 2.78034 0.544922 2.60938C0.87923 2.43855 1.28158 2.46964 1.58594 2.68945L9 8.04395V4C9 3.6239 9.21076 3.27909 9.5459 3.1084C9.88103 2.93774 10.2837 2.97026 10.5879 3.19141L21 10.7637V2H23V22ZM2 18.1309L9.44531 13.168C9.7521 12.9634 10.1466 12.9443 10.4717 13.1182C10.7968 13.2922 11 13.6312 11 14V18.0361L19.2998 12L11 5.96289V10C11 10.3755 10.7894 10.7197 10.4551 10.8906C10.1208 11.0614 9.71842 11.0304 9.41406 10.8105L2 5.45508V18.1309Z" fill="#000" />
  </StyledIcon>
));

ChapterNext.displayName = 'ChapterNext';

export { ChapterNext };
